import React from 'react';

import SvgContainer from '../SvgContainer';

const Shield = () => {
    return (
        <SvgContainer>
            <path d="M8.43627 0.211527C8.16076 0.0779454 7.83924 0.0779454 7.56373 0.211527L2.56373 2.63577C2.21895 2.80294 2 3.15241 2 3.53558V7.27273C2 11.2083 4.43378 14.895 7.74404 15.9261C7.91069 15.978 8.08931 15.978 8.25596 15.9261C11.5662 14.895 14 11.2083 14 7.27273V3.53558C14 3.15241 13.7811 2.80294 13.4363 2.63577L8.43627 0.211527ZM7.27813 10.9693C6.94937 11.328 6.38396 11.328 6.0552 10.9693L4.42966 9.19599C4.18656 8.93079 4.18656 8.52375 4.42966 8.25855C4.70422 7.95903 5.17628 7.95858 5.45141 8.25757L6.66667 9.57818L10.5456 5.34664C10.8218 5.04526 11.2972 5.0461 11.5724 5.34844C11.8146 5.61447 11.8139 6.02124 11.5708 6.28641L7.27813 10.9693Z" />
        </SvgContainer>
    );
};

export default Shield;
